// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LngW","field":"styles_field__3-NQ3","fieldCol":"styles_fieldCol__2s0Ik","diffCol":"styles_diffCol__8WUAo","diff":"styles_diff__3W4ZF"};